import React from 'react';
import MainLayout from '../layouts/MainLayout';
import UserHistoryPanel from '../components/history/UserHistoryPanel';

const HistoryView = () => {
  return (
    <MainLayout>
      <div className='max-w-7xl mx-auto p-6'>
        <UserHistoryPanel title='History' />
      </div>
    </MainLayout>
  );
};

export default HistoryView;
